/**
 * Function to get the cart add condition based on the selection method.
 *
 * @param {string} Selection_method - The method of selection.
 * @param {number} adult_count - The number of adults.
 * @param {number} child_count - The number of children.
 * @param {number} guest_count - The total number of guests.
 * @param {number} cabin_count - The total number of cabins.
 * @returns {Object} - The cart add condition with min_qty and max_qty.
 */

export const getGuestAge = (dob, sailing_date) => {
  let dob_date = new Date(dob);
  let sailing_date_date = new Date(sailing_date);
  let age = sailing_date_date.getFullYear() - dob_date.getFullYear();
  let m = sailing_date_date.getMonth() - dob_date.getMonth();
  if (m < 0 || (m === 0 && sailing_date_date.getDate() < dob_date.getDate())) {
    age--;
  }
  return age;
};
export const getSuppCartAddCondition = (bookingDetails, Selection_method) => {
  const adult_count = bookingDetails?.guest_details?.filter((guest) => {
    let age = getGuestAge(guest.dob);
    return age > 13;
  }).length;

  const child_count = bookingDetails?.guest_details?.filter((guest) => {
    const dob = new Date(guest.dob);
    const age = new Date().getFullYear() - dob.getFullYear();
    return age >= 3 && age <= 13;
  }).length;

  const guest_count = adult_count + child_count;
  // const cabin_count = bookingDetails?.room_with_guest_count?.length;
  switch (Selection_method) {
    case "custom 1":
      return {
        min_qty: 1,
        max_qty: 1,
        guest_count: guest_count,
        child_count: child_count,
      };
    case "custom 2":
      return {
        child_min_qty: 1,
        child_max_qty: 1,
        guest_count: guest_count,
        child_count: child_count,
      };
    case "custom 3":
      return {
        min_qty: 1,
        max_qty: 1,
        guest_count: guest_count,
        child_count: child_count,
      };
    case "custom 4":
      return {
        min_qty: 1,
        max_qty: 1,
        guest_count: guest_count,
        child_count: child_count,
      };
    case "custom 5":
      return {
        min_qty: 1,
        max_qty: 1,
        guest_count: guest_count,
        child_count: child_count,
      };
    case "custom 6":
      return {
        min_qty: 1,
        max_qty: Math.ceil(guest_count / 6),
        guest_count: guest_count,
        child_count: child_count,
      };
    case "custom 7":
      return {
        min_qty: 1,
        max_qty: Math.ceil(guest_count / 4),
        guest_count: guest_count,
        child_count: child_count,
      };
    case "custom 8":
      return {
        min_qty: 1,
        max_qty: 1,
        guest_count: guest_count,
        child_count: child_count,
      };
    case "per cabin":
      return {
        min_qty: 1,
        max_qty: 1,
        guest_count: guest_count,
        child_count: child_count,
      };
    case "per person":
      return {
        min_qty: 1,
        max_qty: 1,
        guest_count: guest_count,
        child_count: child_count,
      };
    default:
      return {
        min_qty: 1,
        max_qty: 1,
        guest_count: guest_count,
      };
  }
};
export const getGuestsAsPerCabin = (category_id, bookingDetails) => {
  let guests_in_cabin = bookingDetails.guest_details.filter(
    (guest) =>
      guest.category_id === +category_id?.split("-")[0] &&
      guest.room_id === +category_id?.split("-")[1] &&
      getGuestAge(guest.dob, bookingDetails.sailing_date) >= 3
  );
  return guests_in_cabin;
};
export const getItineraryIdMapping = {
  1: "2-Night Bahamas",
  2: "3-Night Bahamas",
  3: "4-Night Cozumel",
  4: "5-Night Key West and Cozumel",
  5: "5-Night Progreso and Cozumel",
  6: "5-Night Key West and Progreso",
  7: "6-Night Key West & Mexico",
  8: "6-Night Mexico & Key West",
  9: "7-Night Keys, Mexico & Belize",
  10: "7-Night Belize, Keys & Mexico",
  11: "7-Night Keys, Belize & Mexico",
  12: "7-Night Jamaica, Cayman & Mexico",
  13: "5-Night Cozumel and Progreso",
  14: "4-Night Progreso Express",
  15: "7-Night Mexico Trio",
  16: "4-Night Key West & Bahamas (1)",
  17: "4-Night Nassau & Grand Bahama (1)",
  18: "4-Night Nassau & Grand Bahama (2)",
  19: "4-Night Grand Bahama & Nassau",
  20: "4-Night Key West & Bahamas (2)",
  21: "7-Night Mexico, Roatan & Belize",
  22: "2-Night Nassau Getaway",
  23: "3-Night Nassau Weekend",
};

export const itineraryWiseAddonEnabled = (itinerary_ids, itinerary_title) => {
  const getidFromMapping = Object.keys(getItineraryIdMapping).find(
    (itineraryId) => {
      return (
        getItineraryIdMapping[itineraryId].toLowerCase() ===
        itinerary_title.toLowerCase()
      );
    }
  );
  if (typeof itinerary_ids === "undefined") {
    return true;
  }
  if (itinerary_ids === "") return false;
  itinerary_ids = itinerary_ids.split(",");
  if (itinerary_ids.includes(getidFromMapping)) {
    return true;
  } else {
    return false;
  }
};
